export var Labels={paymentOptionDivider:"O realice el pago con tarjeta de cr\xe9dito"};